import { render } from "./BaseButton.vue?vue&type=template&id=187fb49a&scoped=true"
import script from "./BaseButton.vue?vue&type=script&lang=js"
export * from "./BaseButton.vue?vue&type=script&lang=js"

import "./BaseButton.vue?vue&type=style&index=0&id=187fb49a&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\VUE_Tuts\\cybershyft\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-187fb49a"]])

export default __exports__